/**
 * Shipment tracking links for the carriers Green Line actually ships with.
 * Known carrier + tracking number → the carrier's public tracking URL;
 * anything else → null and the UI shows the number as plain text.
 */

const CARRIER_URLS: Array<{ match: RegExp; url: (trackingNumber: string) => string }> = [
  {
    match: /\bups\b/i,
    url: (n) => `https://www.ups.com/track?tracknum=${encodeURIComponent(n)}`,
  },
  {
    match: /\bfedex\b|federal express/i,
    url: (n) => `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(n)}`,
  },
  {
    match: /\busps\b|postal service/i,
    url: (n) => `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(n)}`,
  },
  {
    match: /\bdhl\b/i,
    url: (n) => `https://www.dhl.com/us-en/home/tracking.html?tracking-id=${encodeURIComponent(n)}`,
  },
]

export function trackingUrl(carrier: string | null, trackingNumber: string | null): string | null {
  if (!carrier || !trackingNumber?.trim()) return null
  const entry = CARRIER_URLS.find((c) => c.match.test(carrier))
  return entry ? entry.url(trackingNumber.trim()) : null
}
